import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { formatEuro, formatRevenueEntryDate, formatShortDate } from "./formatters";

const DetailRow = ({ label, value }) => (
  <>
    <dt>{label}</dt>
    <dd>{value}</dd>
  </>
);

const TeamRevenueDetailDialog = ({ open, entry, dateLocale, locale, t, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open || !entry) return null;

  const empty = t("calendar.bookingDetail.none");

  return createPortal(
    <div className="team-booking-detail-root">
      <div
        className="team-booking-detail-overlay"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className="team-booking-detail-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="team-revenue-detail-title"
      >
        <header className="team-booking-detail-header">
          <p className="team-booking-detail-kicker">{t("calendar.revenueDetail.kicker")}</p>
          <h2 id="team-revenue-detail-title">{t("calendar.revenueDetail.title")}</h2>
        </header>
        <dl className="team-booking-detail-grid">
          <DetailRow
            label={t("calendar.revenueDetail.date")}
            value={formatRevenueEntryDate(entry.entryDate, dateLocale)}
          />
          <DetailRow
            label={t("calendar.revenueDetail.amount")}
            value={formatEuro(entry.priceCents, locale)}
          />
          <DetailRow
            label={t("calendar.revenueDetail.massageType")}
            value={entry.massageType || empty}
          />
          <DetailRow
            label={t("calendar.revenueDetail.created")}
            value={formatShortDate(entry.createdAt, dateLocale)}
          />
        </dl>
        <button type="button" className="auth-submit" onClick={onClose}>
          {t("common.close")}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default TeamRevenueDetailDialog;
